/**
 *
 * PatientOverviewPage
 *
 */

import {Component, createRef} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {createStructuredSelector} from "reselect";
import {compose} from "redux";
import injectSaga from "utils/injectSaga";
import injectReducer from "utils/injectReducer";
import AppContainer from "components/AppContainer/AppContainer";
import GlobalMessages from "messages/messages";
import ForegroundBlobFakeModalHeader from "basicComponents/ForegroundBlobFakeModalHeader/ForegroundBlobFakeModalHeader";
import History from "utils/history";
import ForegroundBlob from "basicComponents/ForegroundBlob/ForegroundBlob";
import * as PropTypes from "prop-types";
import PatientOverView from "components/PatientOverview/PatientOverview";
import Pagination from "basicComponents/Pagination/Pagination";
import {getPractice} from "utils/practiceStorage";
import reducer from "./reducer";
import saga from "./saga";
import messages from "./messages";
import {makeSelectPractice} from "../PracticePage/selectors";
import {makeSelectPageNumbers} from "./selectors";
import {withRouter} from "react-router";

export class PatientOverviewPage extends Component {
  static propTypes = {
    filterPatients: PropTypes.func,
    practice: PropTypes.object.isRequired,
    resetPatients: PropTypes.func,
    onEditPatient: PropTypes.func,
    fromNewAppointment: PropTypes.bool,
    onPatientClicked: PropTypes.func,
    onHandleNewPatient: PropTypes.func,
    searchedName: PropTypes.string,
    enableIcons: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.paginationRef = createRef();
  }

  state = {
    filter: this.props.searchedName || this.props.location?.state?.search || "",
    result: [],
  };

  static defaultProps = { fromNewAppointment: false };

  handlePatientFilterChanged = filter => {
    this.setState({ filter });
    this.paginationRef.current.update();
  };

  handleEditPatient = (patient, icon) => {
    if (icon === "ADD") {
      History.push(`treatment/new/${patient.id}`);
      return;
    }

    if (icon === "EDIT") {
      History.push(`treatment/edit/${patient.id}`);
    }
  };

  handleClose = () => {
    History.goBack();
  };

  handleChange = e => {
    this.setState({ filter: e.currentTarget.value });
  };

  handleResult = result => {
    this.setState({ result });
  };

  render() {
    return (
      <div>
        {!this.props.fromNewAppointment ? (
          <AppContainer header={<FormattedMessage {...messages.header} />}>
            <ForegroundBlob fullscreen>
              <ForegroundBlobFakeModalHeader onClose={this.handleClose}>
                <div data-cy="patientsHeader">
                  <FormattedMessage
                    {...GlobalMessages.patient_overview_large}
                  />
                </div>
              </ForegroundBlobFakeModalHeader>
              <PatientOverView
                createPatient={this.props.createPatient}
                practice={this.props.practice}
                initialInputText={History.location.searchText || ""}
                onEditPatient={this.handleEditPatient}
                showArrow={false}
                onFilter={this.handlePatientFilterChanged}
                onChange={this.handleChange}
                value={this.state.filter}
                items={this.state.result}
                maxHeight
                showTableContent
              />
              <Pagination
                url={`/practices/${
                  getPractice().id
                }/patients/pagination/filter`}
                filter={this.state.filter}
                limit={10}
                handleResult={this.handleResult}
                ref={this.paginationRef}
              />
            </ForegroundBlob>
          </AppContainer>
        ) : (
          <ForegroundBlob
            fullscreen
            fromNewAppointment={this.props.fromNewAppointment}
          >
            <PatientOverView
              createPatient={this.props.createPatient}
              practice={this.props.practice}
              initialInputText={History.location.searchText || ""}
              onEditPatient={this.handleEditPatient}
              showArrow={false}
              onFilter={this.handlePatientFilterChanged}
              onChange={this.handleChange}
              value={this.state.filter}
              items={this.state.result}
              maxHeight
              showTableContent
              onHandleNewPatient={this.props.onHandleNewPatient}
              fromNewAppointment={this.props.fromNewAppointment}
              enableIcons={this.props.enableIcons}
              onPatientClicked={this.props.onPatientClicked}
            />
            <Pagination
              url={`/practices/${getPractice().id}/patients/pagination/filter`}
              filter={this.state.filter}
              limit={10}
              handleResult={this.handleResult}
              ref={this.paginationRef}
            />
          </ForegroundBlob>
        )}
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  practice: makeSelectPractice(),
  pageNumbers: makeSelectPageNumbers(),
});

function mapDispatchToProps(dispatch) {
  return {
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: "patientOverviewPage", reducer });
const withSaga = injectSaga({ key: "patientOverviewPage", saga });

export default compose(
  withRouter,
  withReducer,
  withSaga,
  withConnect,
)(PatientOverviewPage);
